import { Link } from "react-router-dom";
import { Truck } from "lucide-react";

export default function NotFound() {
    return (
        <div
            data-testid="not-found-page"
            className="min-h-[70vh] flex items-center justify-center px-4"
        >
            <div className="text-center max-w-lg">
                <div className="w-16 h-16 rounded-2xl bg-slate-900 text-white flex items-center justify-center mx-auto mb-8">
                    <Truck className="w-8 h-8" />
                </div>
                <div className="font-display text-8xl font-black text-slate-900 tracking-tighter">
                    404
                </div>
                <h1 className="mt-3 font-display text-2xl font-bold text-slate-900">
                    This lane doesn&apos;t exist.
                </h1>
                <p className="mt-3 text-slate-600">
                    Looks like this page took a wrong turn. Let&apos;s get you back on the
                    main route.
                </p>
                <Link
                    to="/"
                    className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-900 text-white font-semibold hover:bg-blue-600 transition-colors"
                >
                    Back to home
                </Link>
            </div>
        </div>
    );
}
